import React, { Ref } from "react";

import { FieldWrapper, FieldWrapperProps } from "shared/components/Form/Fields/FieldWrapper";
import { InputFieldWrapper } from "../styles";
import { StyledTextArea } from "./styles";

interface TextAreaProps extends FieldWrapperProps {
  rows?: number;
  cols?: number;
  value?: string;
  disabled?: boolean;
  readOnly?: boolean;
  placeholder?: string;
  required?: boolean;
  registerRef?: Ref<HTMLTextAreaElement>;
  onChange?: (e: any) => void;
}

export const TextArea: React.FC<TextAreaProps> = ({
  name,
  value,
  placeholder,
  disabled,
  readOnly,
  required,
  error,
  registerRef,
  rows = 4,
  cols,
  onChange,
  tabIndex,
  ...rest
}) => {
  return (
    <FieldWrapper name={name} required={required} error={error} {...rest}>
      <InputFieldWrapper isDisabled={disabled || readOnly} error={!!error}>
        <StyledTextArea
          id={name}
          name={name}
          value={value}
          ref={registerRef}
          placeholder={placeholder}
          disabled={disabled}
          readOnly={readOnly}
          rows={rows}
          cols={cols}
          aria-required={required}
          onChange={onChange}
          tabIndex={tabIndex}
        />
      </InputFieldWrapper>
    </FieldWrapper>
  );
};
